export default __webpack_public_path__ + "static/media/how-does-it-work-2.76d83b9d.png";